import React from "react";
import "./Card.css";
import { IconContext } from "react-icons";
import { AiOutlineClose } from "react-icons/ai";
import { VscCopy } from "react-icons/vsc";
import ReactMarkdown from 'react-markdown';
import ErrorBoundary from './ErrorBoundary';
import OpenAI from "./images/openai.png";
import HuggingFace from "./images/huggingfaceicon.png";
import anthropic from "./images/anthropic.png";
import PaLM from "./images/Google_PaLM_Logo.png";
import Gemini from "./images/Google-Gemini.webp";
import GrokAI from "./images/GrokAI.png";
import rehypeRaw from 'rehype-raw';

class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            usage: this.props.usage,
            output: "",
            model: this.props.model,
            cardCreated: this.props.cardCreated,
            darkMode: this.props.darkMode,
            cardOutput: "",
            output2: ""
        }
        this.ai = this.ai.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.darkMode !== prevState.darkMode) {
            return {
                darkMode: nextProps.darkMode
            };
        }
        return null;
    }

    renderMarkdown(content) {
        // console.log('renderMarkdown input:', content);

        if (!content) {
            // console.log('Content is null or undefined');
            return null;
        }

        // If it's a React element, skip rendering
        if (React.isValidElement(content)) {
            // console.log('Content is a React element, skipping');
            return null;
        }

        let text = '';
        try {
            if (typeof content === 'string') {
                // console.log('Content is a string');
                text = content;
            } else if (Array.isArray(content)) {
                // console.log('Content is an array:', content);
                // Handle array of strings or React elements
                text = content.map(item => {
                    if (typeof item === 'string') {
                        return item;
                    } else if (React.isValidElement(item)) {
                        return ''; // Skip React elements
                    } else if (typeof item === 'object') {
                        return JSON.stringify(item);
                    }
                    return String(item);
                }).join('');
            } else if (content && typeof content === 'object') {
                // console.log('Content is an object:', content);
                text = JSON.stringify(content);
            }
        } catch (e) {
            console.error('Error converting content to string:', e);
            return null;
        }

        // console.log('Final text to render:', text);

        if (!text || text === 'null' || text === 'undefined') {
            // console.log('Text is empty or null/undefined');
            return null;
        }

        return (
            <ErrorBoundary>
                <div className="line markdown-content">
                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                        {text}
                    </ReactMarkdown>
                </div>
            </ErrorBoundary>
        );
    }

    ai() {
        const modelData = {
            "hf": {
                title: "HuggingFace",
                src: HuggingFace,
                alt: "huggingface",
                extraText: "@meta-llama/Llama-2-7b-chat-hf"
            },
            "openai": {
                title: "OpenAI",
                src: OpenAI,
                alt: "openai",
                extraText: ""
            },
            "anthropic": {
                title: "Anthropic",
                src: anthropic,
                alt: "anthropic",
                extraText: ""
            },
            "Grok AI": {
                title: "Grok AI",
                src: GrokAI,
                alt: "Grok AI",
                extraText: ""
            },
            "Google Gemini": {
                title: "Google Gemini",
                src: Gemini,
                alt: "Gemini",
                extraText: ""
            },
            "assistant": {
                title: "assistant",
                extraText: ""
            }
        };

        const currentModel = modelData[this.props.model];
        const { output } = this.props;

        // console.log('Card output:', output);
        // console.log('Output type:', typeof output);
        if (Array.isArray(output)) {
            // console.log('Output is array, length:', output.length);
        }

        if (!currentModel) {
            // console.log('No current model found');
            return null;
        }

        const renderContent = () => {
            if (currentModel.title === "assistant" && !output) {
                // console.log('Assistant model with no output');
                return null;
            }

            const markdownContent = this.renderMarkdown(output);
            if (!markdownContent) {
                // console.log('No markdown content generated');
                return null;
            }

            return (
                <div className="cardInfo">
                    <div className="cardTitle">
                        {currentModel.title !== "assistant" && (
                            <img
                                title={currentModel.title}
                                className="openai"
                                src={currentModel.src}
                                alt={currentModel.alt}
                            />
                        )}
                        <div className="codex poweredBy neonText">
                            {currentModel.title} {currentModel.extraText}
                        </div>
                    </div>
                    {markdownContent}
                    <p className={this.state.darkMode === false ? "cardCreated" : "cardCreated-dark"}>
                        {this.props.cardCreated}
                    </p>
                </div>
            );
        };

        return renderContent();
    }

    render() {
        const renderIconButton = (icon, action) => (
            <div className="iconButton" onClick={action}>
                <IconContext.Provider value={{ size: "1.35em", style: { paddingRight: "0.2rem", marginTop: "0.1rem" } }}>
                    {icon}
                </IconContext.Provider>
            </div>
        );

        return (
            <ErrorBoundary>
                <div className={this.state.darkMode === false ? "card" : "card-dark"}>
                    <div className="cardBtns">
                        <div className="closeBtn" onClick={() => this.props.closeCard(this.props.index)}>
                            <IconContext.Provider value={{ size: "1.35em", style: { paddingRight: "0.2rem", marginTop: "0.1rem" } }}>
                                <AiOutlineClose />
                            </IconContext.Provider>
                        </div>
                        <div className="copyBtn" onClick={() => this.props.copyCard(this.props.index)}>
                            <IconContext.Provider value={{ size: "1.35em", style: { paddingRight: "0.2rem", marginTop: "0.1rem" } }}>
                                <VscCopy />
                            </IconContext.Provider>
                        </div>
                    </div>
                    {this.ai()}
                </div>
            </ErrorBoundary>
        );
    }
}

export default Card;

